import { Injectable, Injector, Inject } from '@angular/core';
import { isString, find } from 'lodash';

import { BaseFormService } from '../base';
import { IBaseFormService } from '@app/shared/types/ui/form-service.type';
import { ENTITY_TYPES } from '@app/shared/types/enums/entityTypes.enum';

@Injectable()
export class EntityFormServiceProvider {
  public service: IBaseFormService<any>;
  public fallbackServiceClass: any = this.getServiceClass('BaseFormService');

  public constructor(
    public injector: Injector,
    @Inject('EntityFormServices') public entityFormServices,
  ) {}

  public getServiceClass(predicate: any): IBaseFormService<any> {
    const findCriteria = isString(predicate)
      ? { ENTITY_TYPE: predicate }
      : predicate;

    return find(this.entityFormServices, findCriteria);
  }

  public getService<R extends BaseFormService = BaseFormService>(
    predicate: any,
    notFoundValue?,
  ): R {
    const serviceClass =
      this.getServiceClass(predicate) || this.fallbackServiceClass;
    const service = this.injector.get(serviceClass, notFoundValue);

    // use and configure fallback service
    if (serviceClass === this.fallbackServiceClass && isString(predicate)) {
      service.entityType = predicate as ENTITY_TYPES;
      service.ENTITY_TYPE = predicate as ENTITY_TYPES;
    }

    return service;
  }
}
